import logger from '@/logger';
import EventBus from '@/EventBus';
import Api from './api';

export default {
  fetchOne: async ({ commit, dispatch }, payload) => {
    try {
      const res = await Api.getRecording(payload.recordingId);
      logger.log('setRecording', res.data);
      commit('setRecording', res.data);
      dispatch(
        'getEvents',
        {
          recordingId: payload.recordingId,
          start: new Date(res.data.videos[0].start),
          end: new Date(res.data.videos[0].end),
        },
      );
    } catch (err) {
      if (err.response && err.response.status === 403) {
        dispatch('users/logout', {}, { root: true });
      }
      logger.log('fetchOne error:', err.message);
    }
  },
  fetchAll: async ({ commit, dispatch }, projectId) => {
    if (!projectId) return;
    try {
      const res = await Api.getAllRecordings(projectId);
      commit('setRecordings', res.data);
    } catch (err) {
      if (err.response.status === 403) {
        dispatch('users/logout', {}, { root: true });
      }
      logger.log('fetchAll error', err.message);
    }
  },
  getEvents: async ({ commit, dispatch }, payload) => {
    try {
      const res = await Api.getEvents(payload.recordingId, payload.start, payload.end);
      commit('setEvents', res.data);
    } catch (err) {
      if (err.response.status === 403) {
        dispatch('users/logout', {}, { root: true });
      }
      logger.log('getEvents error', err.message);
    }
  },
  updateVideoTime: async ({ commit }, payload) => {
    try {
      commit('updateVideoTime', payload);
    } catch (err) {
      logger.log('updateVideoTime error', err.message);
    }
  },
  // Start EventBus related actions
  playVideo: ({ commit }) => {
    EventBus.$emit('video/play');
    commit('selectIssue', null);
  },
  videoPlaying: ({ commit }) => {
    commit('playVideo');
  },
  pauseVideo: () => {
    EventBus.$emit('video/pause');
  },
  videoPaused: ({ commit }) => {
    commit('pauseVideo');
  },
  seekVideo: ({ state, commit }, payload) => {
    EventBus.$emit('video/seekTo', payload);
    commit('seekingVideo');
    commit('selectIssue', null);
  },
  seekingComplete: ({ commit }) => {
    commit('seekingComplete');
  },
  selectIssue: ({ state, commit, dispatch, getters }, issue) => {
    commit('selectIssue', issue._id);
    if (state.videoReady && state.videoPlaying) {
      dispatch('pauseVideo');
    }
    if (state.videoReady) {
      // don't go through action, because normal seek clears selected issue
      EventBus.$emit('video/seekTo', issue.playbackPosInMS);
    } else {
      commit('aspirationalSeek', issue.playbackPosInMS);
    }
  },
  videoReady: ({ commit, state }) => {
    commit('videoReady');
    commit('seekingComplete');
    if (state.aspirationalSeekMS) {
      EventBus.$emit('video/seekTo', state.aspirationalSeekMS);
      commit('aspirationalSeek', null);
    }
  },
  videoError: ({ commit }, error) => {
    commit('videoError', error);
  },
  clear: ({ commit }) => {
    commit('CLEAR');
  },
  async update({ commit }, payload) {
    commit('UPDATING', payload);
    const { recordingId } = payload;
    try {
      await Api.updateRecording(recordingId, payload);
      commit('UPDATED', payload);
    } catch (error) {
      commit('UPDATE_ERROR', { ...payload, error });
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/recordings/actions.js